import { Avatar, Button, Grid, Pagination, ListItem, ListItemAvatar, ListItemText, Accordion, AccordionDetails, AccordionSummary, Typography, CircularProgress, Link, Tooltip } from '@mui/material';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useNavigate } from 'react-router-dom';
import EmployeeDetailPageStore from '../store/EmployeeDetailPageStore';
import { TaskModel } from 'domains/models/TaskModel';
import { toJS } from 'mobx';
import CheckModal from './CheckModal';
import { AssessModel } from 'domains/models/AssessModel';
import moment from 'moment';
import useSnackbarMessage from 'shared/snackbar';
import SendIcon from '@mui/icons-material/Send';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import outlookIcon from '../../../assets/image/outlookIcon.svg';
import teamsIcon from '../../../assets/image/teamsIcon.svg';

import styled from '@emotion/styled';
import bluePin from '../../../assets/image/bluePin.png';
import redPin from '../../../assets/image/redPin.png';
import BasicImage from 'pages/MyPage/component/BasicImage';
import Grid2 from '@mui/material/Unstable_Grid2';
import ImageIcon from '@mui/icons-material/Image';
import { useMediaQueryState } from '../../../hooks/useMediaQueryState';
import { useRootStore } from 'store/StoreContextProvider';
import HTMLContentModal from './HTMLContentModal';
import { grey } from '@mui/material/colors';

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  '&::before': {
    display: 'none',
  },
  '& .MuiButtonBase-root .MuiAccordionSummary-root .Mui-expanded': {
    minHeight: '42px',
  },
  '& .MuiAccordionSummary-content': {
    margin: '0px',
  },
  '& .MuiAccordionDetails-root': {
    padding: 0,
  },
}));

const activeStyle = {
  background: '#ffffff',
  border: '1px solid #2281D0',
  width: '33px',
  height: '33px',
  cursor: 'pointer',
  borderRadius: '50%',
  paddingTop: '5px',
};

interface Props {
  pageStore: EmployeeDetailPageStore;
}
function TaskList(props: Props) {
  const { pageStore } = props;
  const snackbar = useSnackbarMessage();
  const { loginStore, headerStore } = useRootStore();
  const navigate = useNavigate();

  const [emoji, setEmoji] = React.useState();
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [flag, setFlag] = React.useState<boolean>(false);
  const { isPC } = useMediaQueryState();

  const handleClickEmoji = (emoji: any) => {
    setEmoji(emoji);
  };

  const handleChangeAccordion = (task: TaskModel, panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
    pageStore.setSelectedTask(task);
  };

  const handleClickCreateVisibleAdvice = (task: TaskModel, assess?: AssessModel) => {
    if (assess) {
      pageStore.setSelectedAssess(assess);
    }

    pageStore.setSelectedTask(task);
    if (pageStore.tabsValue === 'TODO') {
      pageStore.setIsOpenModal(true);
    } else {
      pageStore.setIsOpenEditModal(true);
    }
  };

  const onClickOpenOk = () => {
    console.log(pageStore.employee);
    navigate('/employee-detail/open', {
      state: {
        employee: toJS(pageStore.employee),
        task: toJS(pageStore.selectedTask),
      },
    });
    pageStore.setOpenPopper(false);
  };

  const onClickOpenUpdateOk = () => {
    navigate('/employee-detail/open', {
      state: {
        employee: toJS(pageStore.employee),
        task: toJS(pageStore.selectedTask),
        assess: toJS(pageStore.selectedAssess),
      },
    });
  };

  const handleChangePagination = (event: React.ChangeEvent<unknown>, page: number) => {
    pageStore.fetchMoreDoneTaskList();
  };

  const onClickCloseOk = () => {
    console.log(pageStore.employee, pageStore.selectedTask);
    headerStore.setIsDoneAssess(true);
    navigate('/employee-detail/close', {
      state: {
        employee: toJS(pageStore.employee),
        task: toJS(pageStore.selectedTask),
      },
    });
    pageStore.setOpenPopper(false);
  };

  const onClickCloseUpdateOk = () => {
    navigate('/employee-detail/close', {
      state: {
        employee: toJS(pageStore.employee),
        task: toJS(pageStore.selectedTask),
        assess: toJS(pageStore.selectedAssess),
      },
    });
  };

  const handleClickArrowRightBtn = () => {
    setFlag(false);
  };

  const handleClickCreateInvisibleAdvice = (task: TaskModel, assess?: AssessModel) => {
    if (assess) {
      pageStore.setSelectedAssess(assess);
    }

    pageStore.setSelectedTask(task);
    if (pageStore.tabsValue === 'TODO') {
      pageStore.setIsCloseModal(true);
    } else {
      pageStore.setIsCloseEditModal(true);
    }
  };

  const renderLockIcon = (child: AssessModel) => {
    if (child.subtype === 'VISIBLE') {
      return <LockOpenIcon />;
    } else {
      return <LockIcon />;
    }
  };
  const renderPinIcon = (child: AssessModel) => {
    if (child.userData?.like === 'true') {
      return <img src={bluePin} alt='bluePin' />;
    } else if (child.userData?.like === 'false') {
      return <img src={redPin} alt='redPin' />;
    }
  };

  const renderPrimary = (task: TaskModel) => {
    if (task.subtype === 'CHAT') {
      if (task.userData?.body?.contentType === 'html') {
        let content = task.userData?.body?.content
          ?.replace(/(<([^>]+)>)/gi, '')
          .replace(/&quot;/g, '')
          .replace(/\"n/, '')
          .replace(/&amp;/g, '')
          .replace(/&nbsp;/g, '');

        content = content
          ?.split('<')
          .filter((el: any) => !el.startsWith('img'))
          .filter((el: any) => !el.startsWith('div>&nbsp'))
          ?.join('<');
        return (
          <div>
            <div
              style={{
                maxHeight: '49px',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '16px',
                color: '#171918',

                overflow: 'hidden',
                textOverflow: 'ellipsis',
                cursor: 'pointer',
              }}
              onClick={() => {
                pageStore.setSelectedTask(task);
                pageStore.setIsHTMLOpen(true);
              }}
              dangerouslySetInnerHTML={{
                __html: content as any,
              }}
            ></div>

            <Grid container justifyContent={'space-between'} alignContent='center'>
              <p
                style={{
                  fontFamily: 'Pretendard',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '12px',
                  color: '#ABABAB',
                }}
              >
                {moment(task.userData.createdDateTime).format('YYYY/MM/DD')}
              </p>
            </Grid>
          </div>
        );
      } else {
        let content = task.userData?.body?.content?.split('<')[0];

        return (
          <div
            style={{
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '16px',
              color: '#171918',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {content}

            <Grid container justifyContent={'space-between'} alignContent='center'>
              <p
                style={{
                  fontFamily: 'Pretendard',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '12px',
                  color: '#ABABAB',
                }}
              >
                {moment(task.userData?.createdDateTime).format('YYYY/MM/DD')}
              </p>
            </Grid>
          </div>
        );
      }
    } else {
      if (task.userData?.bodyPreview) {
        return (
          <div
            style={{
              fontStyle: task.children && task?.children[0]?.userData?.skip ? 'italic' : 'normal',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '16px',
              color: '#171918',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
            }}
            onClick={() => {
              pageStore.setSelectedTask(task);
              pageStore.setIsHTMLOpen(true);
            }}
          >
            {task.title}
            <p
              style={{
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '14px',
                color: '#171918',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {task.userData?.bodyPreview}
            </p>
            <Grid container justifyContent={'space-between'} alignContent='center'>
              <p
                style={{
                  fontFamily: 'Pretendard',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '12px',
                  color: '#ABABAB',
                }}
              >
                {moment(task.userData.receivedDateTime).format('YYYY/MM/DD')}
              </p>
            </Grid>
          </div>
        );
      }
      return (
        <div
          style={{
            fontStyle: task.children && task?.children[0]?.userData?.skip ? 'italic' : 'normal',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            color: '#171918',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            cursor: 'pointer',
          }}
          onClick={() => {
            pageStore.setSelectedTask(task);
            pageStore.setIsHTMLOpen(true);
          }}
        >
          {task.title}
          <p
            style={{
              fontFamily: 'Pretendard',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '12px',
              lineHeight: '12px',
              color: '#ABABAB',
            }}
          >
            {moment(task.userData?.receivedDateTime).format('YYYY/MM/DD')}
          </p>
        </div>
      );
    }
  };

  const renderEmoticion = (children: AssessModel[] | undefined) => {
    return (
      <Grid container alignItems={'center'} justifyContent='space-between'>
        <Grid item textAlign={'left'}>
          {children?.map((child: AssessModel, index: number) => {
            return child.userData?.emoticon !== 0 ? <Grid style={{ fontSize: '1.5em' }}>{child.userData?.emoticon}</Grid> : <></>;
          })}
        </Grid>
        <Grid item textAlign={'right'}>
          {children?.map((child: AssessModel, index: number) => {
            return loginStore.isPublic ? (
              child.subtype === 'INVISIBLE' ? (
                <Grid
                  style={{
                    height: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    verticalAlign: 'center',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '14px',
                    color: '#212121',
                    marginRight: '20px',
                  }}
                >
                  평가점수:
                  {child?.userData?.grade}점
                </Grid>
              ) : (
                <></>
              )
            ) : (
              <></>
            );
          })}
        </Grid>
      </Grid>
    );
  };

  const renderSkipEmoticon = () => {
    return (
      <Grid container style={{ paddingLeft: '2px' }}>
        <Grid item xs={1} alignSelf='center' onClick={handleClickArrowRightBtn}>
          <ArrowForwardIosOutlinedIcon style={{ cursor: 'pointer', width: 12, height: 12, marginLeft: 3 }} />
        </Grid>
        <Grid xs={11} item container direction={'column'}>
          <Grid item container justifyContent={'space-between'}>
            <Grid item>
              <Button
                style={{
                  color: '#171918',
                  fontSize: '12px',
                }}
                onClick={handleClickSkipBtn}
              >
                SKIP
              </Button>
            </Grid>
            <Grid item>
              <Button
                style={{
                  color: '#171918',
                  fontSize: '12px',
                  fontWeight: 700,
                }}
                onClick={handleClickSaveBtn}
              >
                SAVE
              </Button>
            </Grid>
          </Grid>
          <Grid
            item
            container
            style={{
              background: '#FFFFFF',
              borderRadius: '10px',
              width: '208px',
              height: '90px',
              padding: '2px 8px',
              // margin: "10px auto 20px",
            }}
            justifyContent={'center'}
          >
            <Grid container justifyContent={'space-between'} alignItems={'center'}>
              <Grid onClick={() => handleClickEmoji('🙂')} style={emoji === '🙂' ? activeStyle : {}} textAlign='center'>
                🙂
              </Grid>
              <Grid onClick={() => handleClickEmoji('👍')} style={emoji === '👍' ? activeStyle : {}} textAlign='center'>
                👍
              </Grid>
              <Grid onClick={() => handleClickEmoji('⭕')} style={emoji === '⭕' ? activeStyle : {}} textAlign='center'>
                ⭕
              </Grid>
            </Grid>
            <Grid container justifyContent={'space-between'} style={{ marginTop: '3px' }}>
              <Grid onClick={() => handleClickEmoji('😐')} style={emoji === '😐' ? activeStyle : {}} textAlign='center'>
                😐
              </Grid>
              <Grid onClick={() => handleClickEmoji('🤔')} style={emoji === '🤔' ? activeStyle : {}} textAlign='center'>
                🤔
              </Grid>
            </Grid>
            <Grid container justifyContent={'space-between'} style={{ marginTop: '3px' }}>
              <Grid onClick={() => handleClickEmoji('😥')} style={emoji === '😥' ? activeStyle : {}} textAlign='center'>
                😥
              </Grid>
              <Grid onClick={() => handleClickEmoji('👎')} style={emoji === '👎' ? activeStyle : {}} textAlign='center'>
                👎
              </Grid>
              <Grid onClick={() => handleClickEmoji('❌')} style={emoji === '❌' ? activeStyle : {}} textAlign='center'>
                ❌
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const handleClickPrevData = () => {
    pageStore.fetchPrevData();
  };

  const handleClickNextData = () => {
    pageStore.fetchMoreData();
  };

  const handleClickSkipArrowBtn = (task: TaskModel) => {
    setFlag(true);
    pageStore.setSelectedTask(task);
  };

  const handleClickSkipBtn = () => {
    pageStore.setIsSkipOpenModal(true);
  };

  const handleOnClickConfirmSkip = () => {
    pageStore.setIsSkipOpenModal(false);
    pageStore.createTaskAssess(pageStore.selectedTask!, '', true, loginStore.currentUser);
    snackbar.info('SKIP 처리 되었습니다.');
  };

  const handleClickSaveBtn = () => {
    if (!emoji) {
      snackbar.error('이모티콘을 선택해주세요');
      return;
    }
    if (emoji) {
      pageStore.createTaskAssess(pageStore.selectedTask!, emoji, false, loginStore.currentUser);
      snackbar.success('조언이 저장되었습니다.');
      pageStore.setIsCloseModal(true);
    }
  };

  const handleClickComment = (task: TaskModel, child: AssessModel) => {
    console.log(child);
    console.log(task);
    // 1달전일 경우 에러 내야함.
    if (moment(child.created).valueOf() < moment().subtract(1, 'month').valueOf()) {
      snackbar.error('1달 이내에 작성한 조언만 수정이 가능합니다');
      return;
    }

    pageStore.setSelectedTask(task);
    pageStore.setSelectedAssess(child);
    if (child.subtype === 'VISIBLE') {
      pageStore.setIsOpenEditModal(true);
    } else {
      pageStore.setIsCloseEditModal(true);
    }
  };

  const onClickCancelCheck = () => {
    pageStore.setIsCloseModal(false);
  };

  const checkUrl = (task: TaskModel) => {
    if (task?.userData?.webLink) {
      if (task?.userData?.webLink.startsWith('https:')) {
        return task?.userData?.webLink;
      }
    } else {
      if (task?.userData?.webUrl.startsWith('https:')) {
        return task?.userData?.webUrl;
      }
    }
  };

  return (
    <Grid2 style={{ padding: '0px 20px 80px 20px', marginTop: 10 }}>
      <Paper style={{ position: 'relative', boxShadow: 'none' }}>
        <Grid2 container spacing={2}>
          {pageStore.isLoading ? (
            <Grid container justifyContent={'center'} style={{ marginTop: '150px' }}>
              <CircularProgress />
            </Grid>
          ) : pageStore.taskList.length === 0 ? (
            <Grid container justifyContent={'center'} style={{ marginTop: '150px' }}>
              <Typography>해당 내용이 없습니다.</Typography>
            </Grid>
          ) : (
            pageStore.taskList.map((task, index) => {
              let component = null;
              if (pageStore.tabsValue === 'DONE') {
                component = (
                  <StyledAccordion
                    key={`${task.created}_${index}`}
                    expanded={expanded === `panel${task.id}`}
                    onChange={handleChangeAccordion(task, `panel${task.id}`)}
                    style={{
                      border: '1px solid #dddddd',
                      marginBottom: '14px',
                      borderRadius: '15px',
                      opacity: task.children && task?.children[0]?.userData?.skip ? 0.3 : 1,
                      background: task.children && task?.children[0]?.userData?.skip ? '#D3D3D3' : '',
                    }}
                  >
                    <AccordionSummary
                      sx={{
                        justifyContent: 'normal',
                        padding: 0,
                        display: 'block',
                        position: 'relative',
                      }}
                      id={`panel${index}bh-header`}
                    >
                      <ListItem>
                        <div
                        // onClick={() => handleClickPanel(`panel${task.id}`)}
                        >
                          {expanded === `panel${task.id}` ? (
                            <ExpandLessIcon
                              style={{
                                position: 'absolute',
                                bottom: '15px',
                                right: '10px',
                              }}
                            />
                          ) : (
                            <ExpandMoreIcon
                              style={{
                                position: 'absolute',
                                bottom: '15px',
                                right: '10px',
                              }}
                            />
                          )}
                        </div>
                        <ListItemAvatar>
                          <Link
                            href={checkUrl(task)}
                            target='_blank'
                            style={{
                              color: '#2281D0',
                            }}
                            underline='hover'
                          >
                            <Avatar
                              style={{
                                background: '#EBF8F5',
                              }}
                            >
                              {task.subtype === 'EMAIL' ? (
                                <Tooltip title='아웃룩으로 이동됩니다.'>
                                  <img src={outlookIcon} width='20px' height='20px' alt='outlookIcon' />
                                </Tooltip>
                              ) : (
                                <Tooltip title='팀즈로 이동됩니다.'>
                                  <img src={teamsIcon} width='20px' height='20px' alt='teamsIcon' />
                                </Tooltip>
                              )}
                            </Avatar>
                          </Link>
                        </ListItemAvatar>
                        <ListItemText primary={renderPrimary(task)} secondary={renderEmoticion(task?.children)} />
                      </ListItem>
                    </AccordionSummary>
                    <AccordionDetails>
                      {task.children?.length !== 0 ? (
                        task.children?.map((child: AssessModel, index: number) => {
                          if (child.userData?.skip) {
                            return (
                              <Grid
                                container
                                alignItems={'center'}
                                justifyContent='space-around'
                                style={{
                                  paddingTop: 10,
                                  backgroundColor: '#D3D3D3',
                                  borderRadius: '15px',
                                }}
                              >
                                <Typography>SKIP 된 TASK입니다</Typography>
                                <Grid
                                  container
                                  alignItems={'center'}
                                  justifyContent='space-around'
                                  gap={0.2}
                                  direction={'column'}
                                  style={{
                                    width: '80px',
                                    marginRight: '15px',
                                    paddingBottom: '10px',
                                  }}
                                >
                                  <Button
                                    style={{
                                      color: '#111111',
                                      borderRadius: '6px',
                                      height: '36px',
                                      width: '70px',
                                      marginBottom: '6px',
                                      cursor: 'pointer',
                                      background: '#ffffff',
                                      border: '1px solid #aaaaaa',
                                    }}
                                    onClick={() => handleClickCreateInvisibleAdvice(task)}
                                  >
                                    <div
                                      style={{
                                        fontStyle: 'normal',
                                        fontWeight: 500,
                                        fontSize: '12px',
                                        lineHeight: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <VisibilityOffIcon
                                        style={{
                                          width: 12,
                                          height: 12,
                                          marginRight: 2,
                                        }}
                                      />
                                      <span style={{ width: '40px' }}>비공개</span>
                                    </div>
                                  </Button>
                                  <Button
                                    style={{
                                      background: '#2281D0',
                                      color: '#ffffff',
                                      borderRadius: '6px',
                                      height: '36px',
                                      width: '70px',
                                    }}
                                    onClick={() => handleClickCreateVisibleAdvice(task)}
                                  >
                                    <div
                                      style={{
                                        fontStyle: 'normal',
                                        fontWeight: 500,
                                        fontSize: '12px',
                                        lineHeight: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <SendIcon
                                        style={{
                                          width: 12,
                                          height: 12,
                                          marginRight: 5,
                                        }}
                                      />
                                      <span>공개</span>
                                    </div>
                                  </Button>
                                </Grid>
                              </Grid>
                            );
                          } else {
                            return (
                              <ListItem key={`${task.created}_${index}`}>
                                {child.user?.userData?.profile ? (
                                  <BasicImage
                                    src={child.user?.userData?.profile}
                                    style={{
                                      width: 44,
                                      height: 44,
                                      borderRadius: '50%',
                                      objectFit: 'cover',
                                      overflow: 'hidden',
                                    }}
                                  />
                                ) : (
                                  <Avatar>
                                    <ImageIcon
                                      sx={{
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        overflow: 'hidden',
                                      }}
                                    />
                                  </Avatar>
                                )}

                                <ListItemText
                                  primary={
                                    <span
                                      style={{
                                        fontFamily: 'Pretendard',
                                        fontStyle: 'normal',
                                        fontWeight: 600,
                                        fontSize: '16px',
                                        lineHeight: '16px',
                                        cursor: 'pointer',
                                        color: '#000000',
                                      }}
                                    >
                                      {child.user?.names?.fullname}
                                      <span
                                        style={{
                                          fontFamily: 'Pretendard',
                                          fontStyle: 'normal',
                                          fontWeight: 500,
                                          fontSize: '14px',
                                          lineHeight: '14px',
                                          color: '#212121',
                                          marginLeft: '4px',
                                        }}
                                      >
                                        {child.user?.userData.jobTitle}
                                        <span
                                          style={{
                                            fontWeight: 400,
                                            fontSize: '12px',
                                            lineHeight: '12px',
                                            color: '#6C6B6F',
                                            marginLeft: '4px',
                                          }}
                                        >
                                          {child.user?.userData.deptName}
                                        </span>
                                      </span>
                                    </span>
                                  }
                                  secondary={
                                    <Typography
                                      style={{
                                        fontWeight: 400,
                                        fontSize: '14px',
                                        lineHeight: '14px',
                                        color: '#171918',
                                        marginTop: '4px',
                                        width: '200px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {child.title ? child.title : '내용이 없습니다'}
                                    </Typography>
                                  }
                                  onClick={(e) => handleClickComment(task, child)}
                                  // onClick={(e) => handleClickEmployee(employee)}
                                  style={{
                                    margin: 0,
                                    marginLeft: '16px',
                                  }}
                                />

                                {renderLockIcon(child)}
                                {renderPinIcon(child)}
                              </ListItem>
                              // <ListItem
                              //   key={children.id}
                              //   style={{
                              //     border: "1px solid gray",
                              //     marginBottom: "5px",
                              //   }}
                              // >
                              //   {children.subtype === "VISIBLE" ? (
                              //     <LockOpenIcon />
                              //   ) : (
                              //     <LockIcon />
                              //   )}

                              //   <ListItemText
                              //     primary={children.title}
                              //     onClick={() =>
                              //       handleClickComment(task, children)
                              //     }
                              //   />

                              //   {!children?.userData?.like ||
                              //   children?.userData?.like === "" ? (
                              //     <></>
                              //   ) : children?.userData?.like === "true" ? (
                              //     <img src={bluePin} alt="bluePin" />
                              //   ) : (
                              //     <img src={redPin} alt="redPin" />
                              //   )}
                              // </ListItem>
                            );
                          }
                        })
                      ) : (
                        <Typography>코멘트가 없습니다.</Typography>
                      )}
                    </AccordionDetails>
                  </StyledAccordion>
                );
              } else {
                component = (
                  <ListItem
                    key={`${task.created}_${index}`}
                    style={{
                      height: '130px',
                      border: '1px solid #dddddd',
                      marginBottom: '14px',
                      padding: '18px',
                      borderRadius: '15px',
                    }}
                  >
                    <ListItemAvatar>
                      <Link
                        href={checkUrl(task)}
                        target='_blank'
                        style={{
                          color: '#2281D0',
                        }}
                        underline='hover'
                      >
                        <Avatar
                          style={{
                            background: '#EBF8F5',
                          }}
                        >
                          {task.subtype === 'EMAIL' ? (
                            <Tooltip title='아웃룩으로 이동됩니다.'>
                              <img src={outlookIcon} width='20px' height='20px' alt='outlookIcon' />
                            </Tooltip>
                          ) : (
                            <Tooltip title='팀즈로 이동됩니다.'>
                              <img src={teamsIcon} width='20px' height='20px' alt='teamsIcon' />
                            </Tooltip>
                          )}
                        </Avatar>
                      </Link>
                    </ListItemAvatar>
                    <ListItemText primary={renderPrimary(task)} secondary={renderEmoticion(task.children)} />
                    <Grid container gap={0.2} direction={'column'} style={{ width: '70px', marginRight: '15px' }}>
                      <Button
                        style={{
                          color: '#111111',
                          borderRadius: '6px',
                          height: '36px',
                          width: '70px',
                          marginBottom: '6px',
                          background: '#ffffff',
                          cursor: 'pointer',
                          border: '1px solid #aaaaaa',
                        }}
                        onClick={() => handleClickCreateInvisibleAdvice(task)}
                      >
                        <div
                          style={{
                            fontStyle: 'normal',
                            fontWeight: 500,
                            fontSize: '12px',
                            lineHeight: '12px',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <VisibilityOffIcon style={{ width: 12, height: 12, marginRight: 2 }} />
                          <span style={{ width: '40px' }}>비공개</span>
                        </div>
                      </Button>
                      <Button
                        style={{
                          background: '#2281D0',
                          color: '#ffffff',
                          borderRadius: '6px',
                          height: '36px',
                          width: '70px',
                        }}
                        onClick={() => handleClickCreateVisibleAdvice(task)}
                      >
                        <div
                          style={{
                            fontStyle: 'normal',
                            fontWeight: 500,
                            fontSize: '12px',
                            lineHeight: '12px',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <SendIcon style={{ width: 12, height: 12, marginRight: 5 }} />
                          <span>공개</span>
                        </div>
                      </Button>
                    </Grid>
                    <Grid
                      container
                      alignContent={pageStore.selectedTask?.id === task.id && flag ? '' : 'center'}
                      justifyContent={pageStore.selectedTask?.id === task.id && flag ? '' : 'center'}
                      style={{
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        borderTopRightRadius: '15px',
                        borderBottomRightRadius: '15px',
                        width: pageStore.selectedTask?.id === task.id && flag ? '246px' : '22px',
                        height: 'inherit',
                        background: '#F2F2F2',
                        transition: 'all 0.5s',
                      }}
                    >
                      {pageStore.selectedTask?.id === task.id && flag ? (
                        renderSkipEmoticon()
                      ) : (
                        <Grid onClick={() => handleClickSkipArrowBtn(task)}>
                          <ArrowBackIosOutlinedIcon style={{ cursor: 'pointer', width: 12, height: 12 }} />
                        </Grid>
                      )}
                    </Grid>

                    {/* <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={(e) => handleOpenPopper(e, task)}
                    >
                      <ApprovalIcon />
                    </IconButton> */}
                    {/* //FIXME: innerHTML 예시 */}
                    {/* {task.userData?.body?.contentType === "html" ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: task.userData?.body?.content as any,
                      }}
                    ></div>
                  ) : (
                    <></>
                  )} */}
                  </ListItem>
                );
              }
              return (
                <Grid2 xs={12} sm={12} md={6} style={{ marginTop: 2 }}>
                  {component}
                </Grid2>
              );
            })
          )}

          <Grid container justifyContent={'center'}>
            {pageStore.tabPage > 1 && (
              <Button
                style={{
                  background: '#2281D0',
                  color: '#ffffff',
                  borderRadius: '10px',
                  height: '44px',
                  width: '130px',
                  cursor: 'pointer',
                  marginRight: '20px',
                }}
                onClick={handleClickPrevData}
              >
                <div
                  style={{
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '15px',
                    display: 'flex',
                    cursor: 'pointer',
                    alignItems: 'center',
                  }}
                >
                  PREV
                </div>
              </Button>
            )}

            {pageStore.isMoreBtn && pageStore.taskList.length !== 0 ? (
              <Button
                style={{
                  background: '#2281D0',
                  color: '#ffffff',
                  borderRadius: '10px',
                  height: '44px',
                  width: '130px',
                  // marginLeft: '20px'
                }}
                onClick={handleClickNextData}
              >
                <div
                  style={{
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '15px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  NEXT
                </div>
              </Button>
            ) : (
              <></>
            )}

            {/* <Pagination
                count={pageStore.total / 30}
                size="small"
                onChange={(e: React.ChangeEvent<unknown>, page: number) =>
                  handleChangePagination(e, page)
                }
              /> */}
          </Grid>
        </Grid2>
      </Paper>
      {/* FIXME: popper필요없으면 삭제 추후에 */}
      {/* <Popper
        id={id}
        open={pageStore.openPopper}
        anchorEl={anchorEl}
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps}>
            <Box sx={{ border: 1, p: 1, bgcolor: "background.paper" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    onClick={handleClickCreateVisibleAdvice}
                  >
                    공개
                  </Button>
                  &nbsp;
                  <Button
                    variant="contained"
                    onClick={handleClickCreateInvisibleAdvice}
                  >
                    비공개
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h5" component="h5">
                    👍🙂👌👋😂🤗😤😐
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Fade>
        )}
      </Popper> */}
      {/* 스킵모달창 */}
      <CheckModal isOpen={pageStore.isSkipOpenModal} handleClose={() => pageStore.setIsSkipOpenModal(false)} title='해당 TASK를 SKIP하시겠습니까?' content='' onClickOk={handleOnClickConfirmSkip} onClickCancel={() => pageStore.setIsSkipOpenModal(false)} />
      <CheckModal
        isOpen={pageStore.isOpenModal}
        handleClose={() => pageStore.setIsOpenModal(false)}
        title='공개 평가를 작성하러 가시겠습니까?'
        content='*향후 Done 항목에서 추가 평가는 가능합니다.'
        onClickOk={onClickOpenOk}
        onClickCancel={() => pageStore.setIsOpenModal(false)}
      />
      <CheckModal
        isOpen={pageStore.isCloseModal}
        handleClose={() => pageStore.setIsCloseModal(false)}
        title='비공개 평가를 작성하러 가시겠습니까?'
        content='*향후 Done 항목에서 추가 평가는 가능합니다.'
        onClickOk={onClickCloseOk}
        onClickCancel={onClickCancelCheck}
      />

      <CheckModal isOpen={pageStore.isOpenEditModal} handleClose={() => pageStore.setIsOpenEditModal(false)} title='공개 평가를 작성&수정하러 가시겠습니까?' content='' onClickOk={onClickOpenUpdateOk} onClickCancel={() => pageStore.setIsOpenEditModal(false)} />
      <CheckModal
        isOpen={pageStore.isCloseEditModal}
        handleClose={() => pageStore.setIsCloseEditModal(false)}
        title='비공개 평가를 작성&수정하러 가시겠습니까?'
        content=''
        onClickOk={onClickCloseUpdateOk}
        onClickCancel={() => pageStore.setIsCloseEditModal(false)}
      />
      <HTMLContentModal pageStore={pageStore} isOpen={pageStore.isHTMLOpen} handleClose={() => pageStore.setIsHTMLOpen(false)} onClickCancel={() => pageStore.setIsHTMLOpen(false)} />
    </Grid2>
  );
}

export default observer(TaskList);
